<template>
    <div style="height: 100vh;">
      <div id="videoContainer" ref="playerContainer" class="player"></div>
    </div>
  </template>
  
  <script>
  import OvenPlayer from 'ovenplayer';
  import WebRtcStreamApi from '@/api/webrtc/WebRtcStreamApi';
  
  export default {
    data() {
      return {
        playerInstance: null,
        playerOption: null,
        demoOption: null,
        // message: null,
        // version: null,
        // loadButtonMsg: null,
        // loadButtonColor: null,
        // loadButtonIcon: null,
        // demoOption : {
        //     autoReload: true,
        //     autoReloadInterval: 2000
        // },
        // reloadTimer: null,
        streamUrl: null,
        domain: null,
        signatureQueryKeyName: null,
        signature: null,
        private_key: null,
        // valid_time: null,

      };
    },
    async created(){
        const frontPreUrl = window.location.protocol + '//' + window.location.host;
        const localurl = window.location.href;
      
        const tmpNumber = localurl.replace(frontPreUrl + '/securePlayer?', '');

        // await this.setSecurity(frontPreUrl, tmpNumber);
        await this.setSecurity(tmpNumber);
        this.loadPlayer();
    },
    mounted() {
        // this.loadPlayer();
    },
    methods: {
        b64UrlEnc(str){
            return btoa(str) 
            .replace(/\+/g, '-')
            .replace(/\//g, '_')
            .replace(/=+$/, ''); 
        },
        // b64UrlEncBuffer(buffer){
        //     return btoa(String.fromCharCode(...new Uint8Array(buffer)))
        //     .replace(/\+/g, '-')
        //     .replace(/\//g, '_')
        //     .replace(/=+$/, '');
        // },

        // b64UrlEncBuffer(buffer) {
        //     const binary = Array.from(new Uint8Array(buffer))
        //         .map(b => String.fromCharCode(b))
        //         .join('');
        //     return btoa(binary)
        //         .replace(/\+/g, '-')
        //         .replace(/\//g, '_')
        //         .replace(/=+$/, '');
        // }
        // async generateSignedUrl(params){
        //     // const end = new Date();
        //     // end.setMinutes(end.getMinutes() + 1);
        //     // console.log(end); // 1분 후 시간
        //     // console.log(end.getTime()); // timestamp (밀리초)
        //     const end = Math.floor(Date.now() / 1000) + 60;
        //     const policy = `{"url_expire":${end}000}`;

        //     const base64EncodedPolicy = this.b64UrlEnc(policy);
        //     const hmacString = `${params['sourcefile']}?${params['policyQueryKeyName']}=${params['base64EncodedPolicy']}`;

        //     // HMAC-SHA1 서명 생성
        //     const encoder = new TextEncoder();
        //     const key = await crypto.subtle.importKey(
        //         "raw",
        //         encoder.encode(params['hmacPrivateKey']),
        //         { name: "HMAC", hash: "SHA-1" },
        //         false,
        //         ["sign"]
        //     );

        //     const signatureBuffer = await crypto.subtle.sign(
        //         "HMAC",
        //         key,
        //         encoder.encode(hmacString)
        //     );

        //     const base64EncodedSignature = this.b64UrlEncBuffer(signatureBuffer);

        //     // const finalUrl = `${baseUrl}?${policyQueryKeyName}=${base64EncodedPolicy}&${signatureQueryKeyName}=${base64EncodedSignature}&${domain}`;
        //     const finalUrl = `${params['sourcefile']}?${params['policyQueryKeyName']}=${base64EncodedPolicy}&${params['signatureQueryKeyName']}=${base64EncodedSignature}&domain=${this.domain}`;
        //     this.streamUrl = finalUrl;

        //     this.initSetting();
        //     // console.log("policy:", policy);
        //     // console.log("final_url:", this.finalUrl);
        // },
        // async setSecurity(tmpNumber){
          
        //     const tmp = tmpNumber.split("=")[1] || "";
        //     const match = decodeURIComponent(tmp).match(/(wss:\/\/[^?]+)/);
        //     const sourcefile = match ? `${match[1]}` : null;
        //     this.domain = decodeURIComponent(tmp).match(/domain=([^&]+)/)?.[1];

        //     const policyQueryKeyName = "policy";
        //     const signatureQueryKeyName = "signature";
        //     this.signature = signatureQueryKeyName;
        //     const hmacPrivateKey = "kcinfra2024";

        //     const params = {
        //         sourcefile: sourcefile,
        //         policyQueryKeyName: policyQueryKeyName,
        //         signatureQueryKeyName: signatureQueryKeyName,
        //         hmacPrivateKey: hmacPrivateKey,
        //         tmpNumber: tmpNumber
        //     };
          
        //     await this.generateSignedUrl(params);
        // },
        // async generateSignedUrl(params){

        //     const policy = this.valid_time;

        //     const base64EncodedPolicy = this.b64UrlEnc(policy);

        //     const hmacString = `${params['sourcefile']}?${params['policyQueryKeyName']}=${base64EncodedPolicy}`;

        //     const encoder = new TextEncoder();
        //     const keyData = encoder.encode(params['hmacPrivateKey']);
        //     const messageData = encoder.encode(hmacString);

        //     const key = await crypto.subtle.importKey(
        //         "raw",
        //         keyData,
        //         { name: "HMAC", hash: { name: "SHA-512" } },
        //         false,
        //         ["sign"]
        //     );

        //     const signature = await crypto.subtle.sign("HMAC", key, messageData);

        //     const base64Signature = btoa(
        //         String.fromCharCode(...new Uint8Array(signature))
        //     );

        //     const base64EncodedSignature = this.b64UrlEnc(base64Signature);

        //     // const key = await crypto.subtle.importKey(
        //     //     "raw",
        //     //     encoder.encode(params['hmacPrivateKey']),
        //     //     { name: "HMAC", hash: "SHA-512" },
        //     //     false,
        //     //     ["sign"]
        //     // );

        //     // const signatureBuffer = await crypto.subtle.sign(
        //     //     "HMAC",
        //     //     key,
        //     //     encoder.encode(hmacString)
        //     // );

        //     // const base64EncodedSignature = this.b64UrlEncBuffer(signatureBuffer);

        //     let finalUrl = `${params['sourcefile']}?${params['policyQueryKeyName']}=${base64EncodedPolicy}&${params['signatureQueryKeyName']}=${base64EncodedSignature}`;
        //     if(this.domain != null && this.domain != ''){
        //         finalUrl = finalUrl + `&domain=${this.domain}`;
        //     }
        //     console.log("finalUrl => ", finalUrl);
           
        //     this.streamUrl = finalUrl;

        //     this.initSetting();
        // },
        // async setSecurity(frontPreUrl, tmpNumber){
        async setSecurity(tmpNumber){
          
            const tmp = tmpNumber.split("=")[1] || "";
            const match = decodeURIComponent(tmp).match(/(wss:\/\/[^?]+)/);
            const sourcefile = match ? `${match[1]}` : null;
            // const url = new URL(frontPreUrl);
            // this.domain = url['host'];
            // this.domain = decodeURIComponent(tmp).match(/domain=([^&]+)/)?.[1] ?? null;
            // this.domain = decodeURIComponent(tmp).match(/domain=([^&]+)/)?.[1] || null;

            const frontUrl = `${window.location.protocol}//${window.location.host}`;
            const dataParams = {
                sourcefile: sourcefile,
                ip: frontUrl
            }

            const response = await WebRtcStreamApi.controlOptionApi(dataParams);

            this.streamUrl = response.data;
            // console.log("res => ", response)
           

            this.initSetting();

           
            // console.log("response => ", response)
            // this.domain = response.data.domain;
            // this.private_key = response.data.private_key;
            // this.valid_time = response.data.valid_time;
            // this.domain = response.data.domain;

            // const policyQueryKeyName = "policy";
            // const signatureQueryKeyName = "signature";
            // this.signature = signatureQueryKeyName;
            // // const hmacPrivateKey = "kcinfra2024";

            // const params = {
            //     sourcefile: sourcefile,
            //     policyQueryKeyName: policyQueryKeyName,
            //     signatureQueryKeyName: signatureQueryKeyName,
            //     // hmacPrivateKey: hmacPrivateKey,
            //     hmacPrivateKey: this.private_key,
            //     tmpNumber: tmpNumber
            // };
          
            // await this.generateSignedUrl(params);
        },

        initSetting() {
          
            this.playerOption = {
                autoStart: true,
                autoFallback: true,
                mute: true,
                sources: [],
                doubleTapToSeek: false
            };
            if (this.streamUrl) {
                // console.log("this.streamUrl : ", this.streamUrl)
                // if(this.private_key && this.valid_time) {
                    this.playerOption.sources.push({ type: "webrtc", file: decodeURIComponent(this.streamUrl) });
                    
                    // console.log("playerOption => ", this.playerOption)
                // }
            }
        },

        loadPlayer(){
            if(this.playerInstance){
                this.playerInstance.remove();
                this.playerInstance = null;
            }

            // console.log("확인 => ", this.playerOption)
            if(this.playerOption.sources.length == 0){
                return;
            }

            const option = JSON.parse(JSON.stringify(this.playerOption));
            // console.log('sources : ', this.playerOption.sources);

            this.playerInstance = OvenPlayer.create('videoContainer', option);

            this.playerInstance.on('ready', () => {
                console.log('Player ready.');

                setTimeout(() => {
                    this.playerInstance.play();
                }, 300);
            });

            this.playerInstance.once('error', (e) => {
                console.log("err => ", e);

                setTimeout(() => {
                    this.playerInstance.play();
                }, 300);
            });
        },
    },
    beforeDestroy() {
        if (this.playerInstance) {
            this.playerInstance.destroy();
        }
    },
  };
  </script>
  
  <style>
#videoContainer {
  --op-accent-color: red;
  height: 100%;
}
  </style>
  